export default __webpack_public_path__ + "static/media/422.fed022c8.jpg";